import React from 'react';
import { useApp } from '../../context/AppContext';
import { CHANNEL_META } from '../../utils/helpers';

const FILTERS = ['all','draft','approved','scheduled','published'];

export default function ContentLibrary({ filter, setFilter }) {
  const { contentPieces, schedulePiece, updateContentPiece } = useApp();

  const filtered = contentPieces.filter(p => filter === 'all' || p.status === filter);

  async function openSchedule(pieceId) {
    const date = prompt('Schedule date (YYYY-MM-DD):');
    if (!date) return;
    try {
      await schedulePiece(pieceId, date);
    } catch (err) {
      alert('Failed to schedule: ' + err.message);
    }
  }

  if (contentPieces.length === 0) return null;

  return (
    <div className="library-section">
      <div className="lib-head">
        <div className="lib-title">Content Library</div>
        <div className="lib-filters">
          {FILTERS.map(f => (
            <button key={f} className={`lib-filter ${filter === f ? 'on' : ''}`} onClick={() => setFilter(f)}>
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>
      <p className="drag-hint">💡 Drag cards onto the calendar to schedule them</p>
      <div className="lib-grid">
        {filtered.map(piece => {
          const meta = CHANNEL_META[piece.channel] || {};
          return (
            <div key={piece.id} className={`lib-card ${piece.status === 'approved' ? 'approved' : ''}`}>
              <div className="lc-head">
                <div className="lc-dot" style={{ background:meta.color }} />
                <div className="lc-ch">{meta.emoji} {meta.label}</div>
                <div className="lc-src">{piece.idea_title}</div>
                <span className="lc-status" style={{
                  background: piece.status === 'approved' ? 'var(--mist)' : '#fef3c7',
                  color:      piece.status === 'approved' ? 'var(--leaf)' : '#92400e',
                }}>
                  {piece.status}
                </span>
              </div>
              <div className="lc-body">{piece.content}</div>
              <div className="lc-foot">
                {piece.status === 'approved' && (
                  <button className="btn btn-outline btn-xs" onClick={() => openSchedule(piece.id)}>
                    📅 Schedule
                  </button>
                )}
                {piece.scheduled_date && (
                  <span className="lc-date">{piece.scheduled_date}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
